<template>
  <div>
    <v-menu :close-on-content-click="false" v-model="menu" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateLabel"
          v-bind="attrs"
          v-on="on"
          :label="label"
          :rules="rules"
          :error="error"
          :error-messages="message"
          :disabled="disabled"
          hide-details="auto"
          outlined
          readonly
        />
      </template>
      <v-date-picker
        @change="handleSetDate"
        color="primary"
        :min="minDate"
        :locale="localeLanguage"
        scrollable
        no-title
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SelectDate',

  props: {
    data: {
      type: String,
    },

    rules: {
      type: Array,
    },

    label: {
      type: String,
    },

    minDate: {
      required: false,
    },

    error: {
      type: Boolean,
      default: false,
    },

    message: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      menu: false,
      date: null,
      dateLabel: null,
    }
  },

  watch: {
    data() {
      this.dateLabel = moment(this.data).format('DD/MM/YYYY')
    },
  },

  methods: {
    handleSetDate(date) {
      this.date = date
      this.dateLabel = moment(date).format('DD/MM/YYYY')
      this.$emit('input', this.date)
    },
  },

  computed: {
    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    },
  },

  mounted() {
    if (this.data) {
      this.dateLabel = moment(this.data).format('DD/MM/YYYY')
    }
  }
}
</script>
